import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { ClientGroupSetDefaultCommand, ClientGroupSetDefaultCommandHandlerBase, ClientGroupSetDefaultResponse } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(ClientGroupSetDefaultCommand)
@Injectable({ providedIn: 'root'})
export class ClientGroupSetDefaultCommandHandler {
    private commandHandler: ClientGroupSetDefaultCommandHandlerBase;
    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new ClientGroupSetDefaultCommandHandlerBase(http);
    }

    public async handleAsync(cmd: ClientGroupSetDefaultCommand): Promise<ClientGroupSetDefaultResponse> {
        return await this.commandHandler.handleAsync(cmd);
    }
}
